export default {"src":"/_next/static/media/carrying-boat.colour.16bf306e.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};